<template>
<div>
    <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
    <video width="100%" height="600" controls>
        <source :src="src" :type="data.mime">
    </video>
</div>
</template>

<script>
export default {
    name: 'ContentVideo',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        src() {
            // Verificar se temos uma URL assinada para visualização no localStorage
            const signedApiUrls = localStorage.getItem(`lesson_${this.$route.params.lessonId}_api_urls`);

            if (signedApiUrls) {
                const apiUrls = JSON.parse(signedApiUrls);
                if (apiUrls && apiUrls.downloads && apiUrls.downloads[this.data.id]) {
                    return apiUrls.downloads[this.data.id].show;
                }
            }

            // Se não houver URL assinada, usar a URL normal
            return `/app/files/download/${this.data.id}/${this.data.secret}/show`;
        },
    },
};
</script>

